<template>
  <div
    class="card shadow position-relative"
    style="min-height:120px;"
  >
    <div
      v-if="canEdit"
      class="position-absolute cursor-pointer"
      style="right:8px; top: 8px;"
      @click="edit"
    >
      <v-icon icon="pen" />
    </div>
    <div class="card-body">
      <div class="d-flex flex-column justify-content-around h-100 text-center">
        <div class="d-flex mx-auto mb-1">
          <v-icon
            icon="pin"
            width="24"
            height="24"
          />
        </div>
        <div class="d-flex mx-auto">
          Situation des locaux
        </div>
        <div class="text-center fw-bold">
          {{ local.area }} m²
        </div>
        <div class="text-center fw-bold">
          <p class="mb-0 text-truncate">
            {{ local.address.street }}
          </p>
          <p class="mb-0 text-truncate">
            {{ local.address.postalCode }}, {{ local.address.city }} - {{ local.address.country }}
          </p>
        </div>
        <div class="text-center fw-bold">
          {{ local.occupant.label }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    isEditable: {
      type: Boolean,
      default: false,
    },
    local: {
      type: Object,
      required: true,
      default: () => ({
        occupant: { label: null },
        area: null,
        address: {
          street: null,
          postalCode: null,
          city: null,
          country: null,
        },
      }),
    },
  },
  emits: ['edit'],
  computed: {
    ...mapGetters({
      contract: 'contract/get',
    }),
    canEdit() {
      return this.isEditable && this.contract.status === 'AMENDMENT';
    },
  },
  methods: {
    edit() {
      this.$emit('edit', 'local');
    },
  },
};
</script>
